// extracted by mini-css-extract-plugin
export default {"aboutContainer":"About_aboutContainer__G2AVQ","heroContainer":"About_heroContainer__Ivhsn","heroTitle":"About_heroTitle__njn75","heroBtn":"About_heroBtn__ypdBS"};